// extracted by mini-css-extract-plugin
export default {"toast":"toast__toast__Q_0rd","toastBody":"toast__toastBody__FRskm"};